let sonikit;
export const init = (instance) => {
  sonikit = instance;
}

export const create = (options) => {
  if (window.self === window.top) {
    // Only run analytics tracking if not in an iframe
    const body = {
      patch_id: options.patch_id || null,
      service_id: options.patch_id || null,
      category: options.category || null,
      media_id: options.media_id || null,
      media_type: options.media_type || null,
      fan: options.fan_id || null,
      page_id: options.page_id || null,
      station_id: options.station_id || null,
      source_url: window.location.href,
      referrer_url: document.referrer
    }
    
    fetch(`${sonikit.base_url}/events`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${sonikit.project.id}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    })
    .then(response => response.json())
    .then(data => {
      // console.log(data)
    })
    .catch(error => console.log(error));
  }
}

export const sendExternalEvent = (project, patch, service) => {
  if (window.self === window.top) {
    // Only run analytics tracking if not in an iframe

    if (project.google_analytics_id && window.gtag) {
      window.gtag('event', patch.action, {
        'service': service.name,
        'media_id': service.media_id,
        'media_type': service.media_type
      })
    }

    if (project.facebook_pixel_id && window.fbq) {
      window.fbq('trackCustom', patch.action, {
        'service': service.name,
        'media_id': service.media_id,
        'media_type': service.media_type
      });
    }
  }
}